import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as ActivityActions from 'shared/Actions/TransactionActivitiesActions';
import TransactionActivity from './TransactionActivity';
import { downloadFileActions } from 'shared/Actions';

const mapStateToProps = state => ({
    transactionActivityData: state.transactionActivityData,
    downloadedFileData: state.downloadedFileData
});

const mapDispatchToProps = {
    ...ActivityActions,
    ...downloadFileActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransactionActivity));
